'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const Relay = require('react-relay');

// Stores
const PriceStore = require('../../../global/stores/PriceStore.es.js');
const ItemStore = require('../../stores/ItemStore.es');
const TourStore = require('../../../components/Tour/TourStore');

// Components
const ItemCTAButtonsWrapper = require('./ItemCTAButtonsWrapper').default;

// Helpers
const provideContext = require('fluxible-addons-react/provideContext');
const connectToStores = require('fluxible-addons-react/connectToStores');
const SV = require('server-vars');
const {type: { TRADE_TOUR }} = TourStore;
const tourTracking = require('../../../global/tracking/tourTracking');
const pageUrl = require('bunsen/helpers/uri').parseUri(global.location, {stripDelimiters: true});
const hasContextTypes = require('../../../global/reactHelpers/hasContextTypes');
const modalActions = require('../../actions/modals');
const hasDataClass = require('../../helpers/componentHasDataClass');

const Buttons = React.createClass(hasContextTypes({
    propTypes: {
        askingPrice: PropTypes.number,
        canonicalUrl: PropTypes.string.isRequired,
        context: PropTypes.object,
        dealerPk: PropTypes.string.isRequired,
        item: PropTypes.object.isRequired,
        itemId: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        vertical: PropTypes.string.isRequired
    },

    _contactDealer() {
        this.context.executeAction(modalActions.contactDealer, {
            itemPk: this.props.itemId,
            tracking: 'contact link in pdp – request price button',
            dealerPk: this.props.dealerPk
        });
    },

    render() {
        const {
            canonicalUrl,
            user,
            item,
            itemId,
            tradeTour,
            context,
            url } = this.props;

        const tracking = {
            pageContext: 'pdp',
            url: canonicalUrl || url,
            emailTmplName: pageUrl.queryKey.e_tmpl || ''
        };

        const requiredProps = [
            'item',
            'itemId',
            'vertical',
            'canonicalUrl',
            'dealerPk',
            'url',
            'askingPrice'
        ];

        let outputProps = {
            className: `pdp-actions-container ${hasDataClass(this.props, requiredProps)}` // TODO classNames
        };

        const buttonProps = {
            addToCart: true,
            context,
            tracking,
            item,
            tradeTour,
            onClick: this._contactDealer
        };

        const buttons = <ItemCTAButtonsWrapper itemId={itemId} props={buttonProps} item={item} user={user || null} />;
        if (buttons) {
            outputProps = Object.assign({}, outputProps, { ref: 'actions', 'data-tn': 'item-actions' });
        }

        return (
            <div {...outputProps}>
                {buttons}
            </div>
        );
    }
}));

const Connected = Relay.createContainer(provideContext(connectToStores(
    Buttons,
    [
        ItemStore,
        PriceStore,
        TourStore
    ],
    context => {
        const itemStore = context.getStore(ItemStore);
        const priceStore = context.getStore(PriceStore);
        const tourStore = context.getStore(TourStore);
        const item = itemStore.getItem();
        const processedPriceData = priceStore.processPrice(item);

        return ({
            askingPrice: itemStore.getFromSV('tracking.initialDataLayerInfo.askingPrice'),
            canonicalUrl: itemStore.getFromSV('data.canonicalUrl'),
            dealerPk: itemStore.getFromSV('data.dealerPk'),
            item,
            itemId: itemStore.getFromSV('data.pk'),
            tradeTour: {
                type: TRADE_TOUR,
                subType: processedPriceData.priceDisplays.showNetPrice ? 'preQuotedNetPrice' : 'requestNetPrice',
                copy: SV.get(`tourCopy.${TRADE_TOUR}`),
                isTourOpen: tourStore.isTourOpen(TRADE_TOUR),
                currentStep: tourStore.getCurrentStep(TRADE_TOUR),
                totalSteps: tourStore.getTotalSteps(TRADE_TOUR),
                onOpen: tourTracking.trackOpen,
                onClose: tourTracking.trackClose
            },
            url: itemStore.getUrl(),
            vertical: itemStore.getFromItemModel('vertical')
        });
    }
)), {
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                ${ItemCTAButtonsWrapper.getFragment('user')}
            }
        `
    }
});

module.exports = {
    Connected,
    Raw: Buttons
};



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Sidebar/Buttons.jsx